import { SelectField } from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { ConfigProvider } from "melco-ui";
import { useInputFormatDropdownData } from "../../hooks/inputFormats/useInputFormatDropdown";

type SelectInputFormatProps = {
  isDisabled?: boolean;
};

export const SelectInputFormat: React.FC<SelectInputFormatProps> = ({
  isDisabled,
}) => {
  const { t } = useTranslation();

  const { isLoading, isFetching, data, isPreviousData } =
    useInputFormatDropdownData();

  const inputFormatOptions = (data ?? []).map((o) => ({
    value: o.id ?? "",
    label: o.display_name ?? "",
  }));

  return (
    <ConfigProvider renderEmpty={() => <>{t("global.fallback.none")}</>}>
      <SelectField
        name="format_id"
        label={t("designMappings.actions.add.form.label.format_id")}
        loading={isPreviousData ? isFetching : isLoading}
        style={{ width: "100%" }}
        options={inputFormatOptions}
        showSearch
        optionFilterProp="label"
        filterOption
        allowClear
        placeholder={t("global.fallback.none")}
        disabled={isDisabled}
      />
    </ConfigProvider>
  );
};
